import "./Footer.scss";
import FooterLogoSvg from "@Assets/svg/Footer/Footerlogo.svg";
import XSvg from "@Assets/svg/Footer/X.svg";
import InstagramSvg from "@Assets/svg/Footer/InstagramIcon.svg";
import FacebookSvg from "@Assets/svg/Footer/FaceBook.svg";
import SocilaiconSvg from "@Assets/svg/Footer/Socila-icon.svg";
import GlobeSvg from "@Assets/svg/Footer/globe.svg";
import { useAppSelector } from "@Src/app/hooks";
import { Link } from "react-router-dom";
import { DetailsRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { ReactComponent as IabhyasLogo } from "@Src/assets/svg/iabhyas-logo.svg";

const Footer = () => {
  const headerStore = useAppSelector((state) => state.header);
  let classes = headerStore.class;
  let splitndex: number = 9;
  let classList;
  if (classes.length > 9) {
    classList = [classes.slice(0, splitndex), classes.slice(splitndex + 1)];
  } else {
    classList = [classes];
  }
  let subjects = headerStore.subject;
  let subjectList;
  if (subjects.length > 9) {
    subjectList = [subjects.slice(0, splitndex), subjects.slice(splitndex + 1)];
  } else {
    subjectList = [subjects];
  }
  let testSeries = headerStore.testSeries;
  let testSeriesList;
  if (testSeries.length > 9) {
    testSeriesList = [
      testSeries.slice(0, splitndex),
      testSeries.slice(splitndex + 1),
    ];
  } else {
    testSeriesList = [testSeries];
  }
  return (
    /* -------------------------footer--------------------------------- */

    <section className="footer-section-container p-0">
      <div className="ia-container">
        {/* <div className="flex tw-justify-center mb-3">
          <IabhyasLogo className="iabhyas-logo" style={{color: '#fff', height: '60px'}} />
        </div>
        
        <p className="text-center text-white">Join the best and most affordable online platform for all your exam preparation needs</p> */}
        {/* <div className="footer-top-sec">          
          <div className="f-t-logo-card">
            <div className="footer-logo">
              <img src={FooterLogoSvg} alt="logo-svg" />
              <IabhyasLogo className="iabhyas-logo" style={{color: '#fff', height: '50px'}} />
            </div>
            <div className="join-para pt-0">
            Join the best and most affordable online platform for all your exam preparation needs
            </div>
          
          </div>
        <div className="f-t-right-sec tw-grow gap-4">
          {classList.length > 0 && (
              <div className="pr-4">
                <p className="tw-text-2xl tw-font-semibold tw-text-white mb-4">Classes</p>
                {classList.map((list: any, index: number) => {
                  return (
                    <>
                      <ul key={index} className="test-list-footer">
                        {list.map((cls: any) => {
                          let name = cls.Name;
                          return (
                            <li key={cls.Id}>
                                <Link
                                  to={`${DetailsRouteURL.CLASSES_DETAILS}/${name}/${cls.Id}`}
                                >
                                  {cls.Name}
                                </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                })}
              </div>
            )}
            {subjectList.length >= 1 && (
              <div className="pr-4">
                <p className="tw-text-2xl tw-font-semibold tw-text-white mb-4">Subject</p>
                {subjectList.map((list: any, index: number) => {
                  return (
                    <>
                      <ul key={index} className="test-list-footer">
                        {list.map((sub: any) => {
                          let name = sub.Name;
                          return (
                            <li key={sub.Id}>
                              
                                <Link
                                  to={`${DetailsRouteURL.SUBJECT_DETAILS}/${name}/${sub.Id}`}
                                >
                                  {sub.Name}
                                </Link>
                              
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                })}
              </div>
            )}

          {testSeriesList.length >= 1 && (
            <div>
              <p className="tw-text-2xl tw-font-semibold tw-text-white mb-4">Test Series</p>
              {testSeriesList.map((list: any, index: number) => {
                return (
                  <>
                    <ul key={index} className="test-list-footer three-column">
                      {list.map((test: any) => {
                        let name = test.Name;
                        
                        return (                         
                            
                              <li key={test.Id} >
                              <Link
                                to={`${TestSereisRouteURL.TEST_SERIES}/${name}/${test.Id}`}
                              >
                                {test.Name}
                              </Link>
                              </li>
                        );
                      })}
                    </ul>
                  </>
                );
              })}
            </div>
          )}
        </div>
        </div> */}

      </div>
      <div className="footer-bottom-sec tw-border-t tw-border-blue-400 tw-border-opacity-50 py-4 mt-0 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-between tw-gap-4">
        <div className="all-right-head lg:tw-ml-5 tw-text-center lg:tw-text-left">
          <p className="tw-inline cursor-pointer hover:tw-text-white tw-transition-colors" onClick={() => {
            window.location.href = `${process.env.REACT_APP_MAIN_SITE_URL}/terms-and-conditions`
          }}>
            Terms & Conditions
          </p> | <p className="tw-inline cursor-pointer hover:tw-text-white tw-transition-colors" onClick={() => {
            window.location.href = `${process.env.REACT_APP_MAIN_SITE_URL}/faq`
          }}>
            FAQ
          </p> | <p className="tw-inline cursor-pointer hover:tw-text-white tw-transition-colors" onClick={() => {
            window.location.href = `${process.env.REACT_APP_MAIN_SITE_URL}/blog`
          }}>
            Blog
          </p>
        </div>
        <div className="tw-text-gray-400 tw-text-center tw-text-sm">
          © {new Date().getFullYear()} iAbhyas. All rights reserved.
        </div>
        <div className="social-media-icons lg:tw-mr-5">
          <a href="https://www.facebook.com/iabhyas/" target="_blank" rel="noreferrer" className="icons-svg hover:tw-opacity-100 tw-opacity-60 tw-transition-opacity">
            <img src={FacebookSvg} alt="facebook-svg" />
          </a>
          <a href="https://x.com/iabhyas1" target="_blank" rel="noreferrer" className="icons-svg hover:tw-opacity-100 tw-opacity-60 tw-transition-opacity">
            <img src={XSvg} alt="x-svg" />
          </a>
          <a href="https://www.instagram.com/iabhyas1/" target="_blank" rel="noreferrer" className="icons-svg hover:tw-opacity-100 tw-opacity-60 tw-transition-opacity">
            <img src={InstagramSvg} alt="instagram-svg" />
          </a>
        </div>
      </div>


    </section>
  );
};

export default Footer;
